export default __webpack_public_path__ + "static/allies-27afc15375ee2f5f238eea7b7d3e7beb.png";